import React, { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Drawer,
  Grid,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import { Close, ExpandMore } from '@mui/icons-material';

import { useCCTableContext } from '../cc-table.context';
import { checkIsFiltered } from '../utils';
import { CCTableCheckboxFilter, CCTableDateFilter, CCTableTextFilter } from '../cc-table-filters';

export const CCTableFilter = () => {
  const theme = useTheme();
  const [{ filterComponent: FilterComponent, filterComponentProps }, setFilterComponent] = useState<{
    filterComponent: any;
    filterComponentProps: any;
  }>({
    filterComponent: null,
    filterComponentProps: {},
  });
  const [visibleFilterDrawer, setVisibleFilterDrawer] = useState<boolean>(false);
  const { columns, filters, updateTableStatus } = useCCTableContext();

  const isFiltered = checkIsFiltered({ filters });

  return (
    <>
      <Grid container spacing={2}>
        <Grid item sx={{ flex: 1 }}>
          <Accordion sx={{ boxShadow: 'none', border: `1px solid ${theme.palette.grey[400]}` }}>
            <AccordionSummary expandIcon={<ExpandMore />} sx={{ minHeight: 56 }}>
              <Typography color="textSecondary">Filter by : </Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ paddingX: 2, paddingTop: 0 }}>
              <Grid container spacing={1}>
                {columns
                  .filter(({ filter }) => filter !== false)
                  .map(({ id, label, filter = true }, index) => {
                    const value = filters[id]?.value || null;

                    let isFiltered = !!value;

                    if (Array.isArray(value)) {
                      isFiltered = value.length !== 0;
                    }

                    return (
                      <Grid key={`filter-item-${index}`} item>
                        <Chip
                          label={label}
                          color="primary"
                          onClick={() => {
                            const filterComponent: any =
                              filter === false
                                ? null
                                : filter === true
                                ? CCTableTextFilter
                                : filter.component ||
                                  (filter.type === 'checkbox'
                                    ? CCTableCheckboxFilter
                                    : filter.type === 'date'
                                    ? CCTableDateFilter
                                    : CCTableTextFilter);

                            const onChange = (value: string | string[] | null) => {
                              updateTableStatus({ filters: { ...filters, [id]: { ...filters[id], value } } });
                            };

                            const onClose = () => {
                              setVisibleFilterDrawer(false);
                            };

                            const filterComponentProps = {
                              value,
                              onChange,
                              onClose,
                              ...(typeof filter === 'boolean' ? {} : filter.componentProps || {}),
                            };

                            setFilterComponent({
                              filterComponent,
                              filterComponentProps,
                            });

                            setVisibleFilterDrawer(true);
                          }}
                          variant={isFiltered ? 'filled' : 'outlined'}
                        />
                      </Grid>
                    );
                  })}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>

        {isFiltered && (
          <Grid item>
            <IconButton color="primary" sx={{ marginTop: 1 }}>
              <Close />
            </IconButton>
          </Grid>
        )}
      </Grid>

      <Drawer
        anchor={'bottom'}
        open={visibleFilterDrawer}
        onClose={() => {
          setVisibleFilterDrawer(false);
        }}
      >
        <FilterComponent {...filterComponentProps} />
      </Drawer>
    </>
  );
};
